import styled, { css } from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray, white, black, red } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  transform: translate3d(0,0,0);
  ${maxmedia.medium`
    overflow-y: scroll;
    background: ${white};
  `};
  ${minmedia.medium`
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  `};
`

export const FormTitle = styled.p`
  margin-top: 2.5rem;
  font-weight: 400;
  &:first-child {
    margin-top: 0;
  }
`

export const Popup = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: scroll;
  padding-bottom: 2rem;
  ${minmedia.medium`
    width: 97%;
    max-height: 100%;
    padding-bottom: 0;
    max-width: 640px;
    border-radius: 0.25rem;
    background: ${white};
    border: 1px solid ${bordergray};
    box-shadow: 0px 1px 8px 3px rgba(0, 0, 0, 0.2);
  `};
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1rem 0.5rem 1rem;

  ${minmedia.medium`
    padding: 2rem;
  `} ${minmedia.medium`
    padding: 1.5rem 2rem;
    border-bottom: 1px solid ${bordergray};
  `};
`

export const Title = styled.h2`
  margin: 0;
  font-weight: 400;
  font-size: 22px;

  ${minmedia.medium`
    font-size: 32px;
  `};
`

export const Form = styled.form`
  width: 100%;
  padding: 1rem;

  & > div {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${minmedia.medium`
    padding: 1rem 2rem;
  `} ${minmedia.medium`
    padding: 2rem;
  `};
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  div:first-child {
    margin-right: 1rem;
  }
  div:hover {
    color: ${white};
  }

  ${maxmedia.medium`
    justify-content: flex-start;

    div:first-child {
      display: none;
    }
  `} ${minmedia.medium`
    margin-top: 1rem;
  `};
`

export const CloseButton = styled.div`
  margin-top: 0.5rem;
  cursor: pointer;

  &:hover {
    fill: ${red};
  }

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${black};
  }

  ${maxmedia.medium`
    display: none;
  `} ${minmedia.medium`
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  `};
`

export const Cancel = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${bordergray};
  cursor: pointer;

  span {
    margin-left: 0.5rem;
  }

  ${minmedia.medium`
    display: none;
  `};
`

export const IconContainer = styled.div`
  svg {
    width: 1rem;
    height: 1rem;
  }
`

export const Feedback = styled.p`
  transition: all 0.5s;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 400;
  text-align: right;

  visibility: hidden;
  z-index: -1;
  opacity: 0;

  color: ${red};

  ${props =>
    props.saved &&
    css`
      visibility: visible;
      z-index: 1;
      opacity: 1;
    `};

  ${props =>
    props.error &&
    css`
      color: ${red};
    `};
`

export const InputFeedback = styled.div`
  margin-bottom: 1rem;
  margin-top: -0.5rem;
  color: ${red};
  font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/FormPopup/styles.js